import React from 'react';
import { motion } from 'framer-motion';
import { SacredGeometry } from './SacredGeometry';
export function WhyOtherApproaches() {
  return <section className="relative w-full bg-cream py-32 px-6 overflow-hidden" data-id="element-520">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] pointer-events-none" data-id="element-521">
        <SacredGeometry data-id="element-522" />
      </div>

      <div className="relative max-w-3xl mx-auto z-10" data-id="element-523">
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="font-serif italic text-teal text-lg md:text-xl text-center tracking-wide uppercase mb-6" style={{
        letterSpacing: '0.15em'
      }} data-id="element-524">
          La diferencia no se explica comparando.
        </motion.p>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="font-serif text-teal-dark text-4xl md:text-5xl lg:text-6xl text-center leading-tight mb-20" data-id="element-525">
          Hay un tipo de búsqueda
          <br data-id="element-526" />
          que conocés bien.
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="space-y-7 text-lg md:text-xl text-gray-700 font-light leading-relaxed" data-id="element-527">
          <p data-id="element-528">No es la primera vez que buscás algo.</p>
          <p data-id="element-529">
            Probaste cosas. Transitaste caminos. Algunos te dieron alivio.
            Otros, comprensión. Algunos te abrieron puertas que no sabías que
            existían.
          </p>
          <p className="font-serif italic text-2xl md:text-3xl text-teal-dark py-4" data-id="element-530">
            Y aun así — algo sigue sin moverse.
          </p>
          <p data-id="element-531">
            No porque lo que hiciste no haya servido. Sino porque cada
            herramienta tiene su alcance. Y hay una capa del campo energético
            que simplemente requiere un tipo de trabajo específico para ser
            alcanzada.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="my-20 flex flex-col items-center" data-id="element-532">
          <div className="flex items-center gap-6 font-serif text-teal-dark text-2xl md:text-3xl tracking-wide" data-id="element-533">
            <span className="italic" data-id="element-534">No mejor.</span>
            <span className="text-gold text-xl" data-id="element-535">·</span>
            <span className="italic" data-id="element-536">No peor.</span>
            <span className="text-gold text-xl" data-id="element-537">·</span>
            <span className="font-medium" data-id="element-538">Específico.</span>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="space-y-7 text-lg md:text-xl text-gray-700 font-light leading-relaxed" data-id="element-539">
          <p className="font-serif italic text-2xl md:text-3xl text-teal text-center" data-id="element-540">
            Eso es lo que hace el Método Llave.
          </p>
          <p className="pt-4" data-id="element-541">
            Llega a la capa que todavía no fue tocada — con herramientas
            diseñadas exactamente para eso — y trabaja con la precisión que solo
            da operar directamente dentro del campo.
          </p>
          <p className="font-serif italic text-xl text-teal-dark text-center pt-6" data-id="element-542">
            Sin suposiciones.
            <br data-id="element-543" />
            Sin protocolos genéricos.
            <br data-id="element-544" />
            Con lo que tu campo muestra.
          </p>
        </motion.div>
      </div>
    </section>;
}